import * as React from 'react';
import { clsx } from 'clsx';
import { Link } from '@cian/ui-kit';

import { ISeoLink } from '../../types/offersData';
import styles from './SeoLinks.css';

interface ISeoLinksProps {
  seoLinks: ISeoLink[];
}

const SPACE_SYMBOL = '\u0020';

export const SeoLinks: React.FC<ISeoLinksProps> = ({ seoLinks }) => {
  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    /*
      Блок в DOM находится наверху по SEO-требованиям, а визуально внизу.
      В плохих условиях (3G) браузерная отрисовка последующих блоков будет сдвигать его вниз, что портит CLS.
      Поэтому визуально отображаем блок позже - когда уже загружен и выполняется JS.
    */
    <div className={clsx(styles['container'], !isMounted && styles['visually-hidden'])}>
      <div className={styles['content']}>
        {seoLinks.map(({ title, url }, index) => (
          <React.Fragment key={index}>
            {!!index && `${SPACE_SYMBOL}|${SPACE_SYMBOL}`}
            <Link href={url} inline color="current_color">
              {title}
            </Link>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
